import { axiosFaturas } from "../../plugins/axiosConnect";

export const state = {}

export const mutations = {}

export const getters = {}

export const actions = {
    getResponsiblePersons(context) {
        return new Promise((resolve, reject) => {
            axiosFaturas.get('monitoring/responsible-persons')
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    console.error('❌ Erro getResponsiblePersons:', error);
                    reject(error)
                })
        })
    },

    getSimpleMonitoring(context, payload) {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();
            params.append('responsible_person', payload.responsible_person);

            if (payload.distributor) {
                params.append('distributor', payload.distributor);
            }
            if (payload.start_date) {
                params.append('start_date', payload.start_date);
            }
            if (payload.end_date) {
                params.append('end_date', payload.end_date);
            }

            axiosFaturas.get(`monitoring/simple?${params.toString()}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    console.error('❌ Erro getSimpleMonitoring:', error);
                    reject(error)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/monitoring.js